import axios from "axios";
import { API_ENDPOINT } from "@/utils/misc";

export const getTemplatesByLocation = (horecaLocationId) => {
  return axios.get(`${API_ENDPOINT()}/template-locations/get-by/location`, {
    params: { horecaLocationId },
  });
};
